import { useContext } from "react";
import { ImportCSVContext } from "./ImportCSVProvider";

export default function useImportCSVContext() {
    return useContext(ImportCSVContext);
};
